import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'ukho-not-found-error',
    standalone: true,
    imports: [RouterLink],
    templateUrl: './not-found-error.component.html',
    styleUrls: ['./not-found-error.component.scss']
})
export class NotFoundErrorComponent {}
